"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _toLower2 = _interopRequireDefault(require("lodash/toLower"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _constants2 = require("../constants");
var _kyc = require("../clients/kyc.client");
var _dec, _class, _descriptor, _descriptor2, _descriptor3;
/**
 * airlines store
 */
let AirlinesStore = (_dec = _mobx.action.bound, (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   */
  function AirlinesStore(initialState = {}) {
    (0, _classCallCheck2.default)(this, AirlinesStore);
    (0, _initializerDefineProperty2.default)(this, "data", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "API_STATE", _descriptor2, this);
    /**
     * fetch airlines
     * @param {Function} errorHandler
     */
    (0, _initializerDefineProperty2.default)(this, "fetch", _descriptor3, this);
    this.updateInitialState(initialState);
  }
  (0, _createClass2.default)(AirlinesStore, [{
    key: "isLoading",
    get:
    /**
     * is loading
     * @return {boolean}
     */

    function () {
      return this.API_STATE[_constants2.ACTION_TYPES_KYC_PREFRENCES.FETCH_AIRLINES] === _constants.API_STATE.LOADING;
    }

    /**
     * is fetched
     * @return {boolean}
     */
  }, {
    key: "isFetched",
    get: function () {
      return this.API_STATE[_constants2.ACTION_TYPES_KYC_PREFRENCES.FETCH_AIRLINES] === _constants.API_STATE.SUCCESS;
    }

    /**
     * has error
     * @return {boolean}
     */
  }, {
    key: "hasError",
    get: function () {
      return this.API_STATE[_constants2.ACTION_TYPES_KYC_PREFRENCES.FETCH_AIRLINES] === _constants.API_STATE.FAILED;
    }

    /**
     * update initial state
     * @param {Object} initialState
     */
  }, {
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }, {
    key: "onSuccess",
    value:
    /**
     * handle success
     * @param data
     * @param actionType
     */
    function onSuccess(data) {
      this.data = data;
      this.API_STATE[_constants2.ACTION_TYPES_KYC_PREFRENCES.FETCH_AIRLINES] = _constants.API_STATE.SUCCESS;
    }

    /**
     * handle error
     * @param error
     * @param errorHandler
     * @param actionType
     */
  }, {
    key: "onError",
    value: function onError(error, errorHandler) {
      errorHandler(error);
      this.API_STATE[_constants2.ACTION_TYPES_KYC_PREFRENCES.FETCH_AIRLINES] = _constants.API_STATE.FAILED;
    }
  }]);
  return AirlinesStore;
}(), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "data", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "API_STATE", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      [_constants2.ACTION_TYPES_KYC_PREFRENCES.FETCH_AIRLINES]: _constants.API_STATE.INITIAL
    };
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isLoading", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLoading"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isFetched", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFetched"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasError", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasError"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "fetch", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return (0, _mobx.flow)(function* ({
      errorHandler = () => {},
      name
    }) {
      this.API_STATE[_constants2.ACTION_TYPES_KYC_PREFRENCES.FETCH_AIRLINES] = _constants.API_STATE.LOADING;
      try {
        const response = yield _kyc.KYCClient.getAirlines({
          name
        });
        this.onSuccess(response);
        return response;
      } catch (error) {
        this.onError(error, errorHandler);
      }
    });
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onSuccess", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSuccess"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onError", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onError"), _class.prototype)), _class));
exports.default = AirlinesStore;